import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import { useAutomationSuggestionsContext } from './Context';
import Content from './Content';

const AutomationSuggestions = (props) => {
  const { AutomationSuggestionsCollection, initializingError, isInitializing } = useAutomationSuggestionsContext();
  return (
    <DataContainer
      component={Content}
      componentProps={{
        collection: AutomationSuggestionsCollection,
      }}
      loading={isInitializing}
      loadingError={initializingError}
      {...props}
    />
  );
};

AutomationSuggestions.propTypes = {
};

export default AutomationSuggestions;
